import { useSelector } from 'react-redux';
import { selectApplication } from '../store/selectors/applicationSelectors';

const useIraApplicationFundingData = () => {
  const Application = useSelector(selectApplication);

  const { IRAApplication } = Application;

  return {
    IraApplicationFundingResponse: {
      ...IRAApplication?.IRAApplicationFundingResponse,
    },
  };
};

export default useIraApplicationFundingData;
